import { useInfiniteQuery } from '@tanstack/react-query';
import {
  SectionContentRelayRequestDto,
  SectionContentRelayResponseDto,
} from '@diritto/common/relay/dtos/section-relay.dtos';
import { RelayApi } from 'api/ApiHelper';
import { relayQueryKey } from 'queries/relay/queryKey';

const DEFAULT_LIMIT = 20;

const getNextPageParam = (lastGroup: SectionContentRelayResponseDto, allGroups: SectionContentRelayResponseDto[]) => {
  if ((lastGroup.section.contentIds.length ?? 0) < DEFAULT_LIMIT) {
    return undefined;
  }
  return allGroups.reduce((acc, current) => acc + current.section.contentIds.length, 0);
};

export const useGetSectionContentInfiniteQuery = (sectionSlug: string, data: SectionContentRelayRequestDto) =>
  useInfiniteQuery({
    queryKey: relayQueryKey.sectionContent(sectionSlug, data),
    queryFn: ({ pageParam = 0 }) =>
      RelayApi.sectionsContent(sectionSlug, data, {
        offset: pageParam,
        limit: DEFAULT_LIMIT,
      }),
    initialPageParam: 0,
    getNextPageParam,
  });
